module.exports = __webpack_public_path__ + "header_two.jpg?f2f2de96e14a40255e93ab5fab29916b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scss/inspinia/img/landing/header_two.jpg
// module id = 614
// module chunks = 0